import React from "react";

const Assets = () => {
  return (
    <div className="container mt-4">
      <h4>Assets</h4>

      <div className="card p-3">
        {/* Top Bar */}
        <div className="d-flex justify-content-between mb-3">
          <div>
            <select className="form-select d-inline w-auto me-2">
              <option>10</option>
            </select>
            Entries
          </div>
          <input className="form-control w-25" placeholder="Search" />
        </div>

        {/* Table */}
        <table className="table">
          <thead>
            <tr>
              <th>Asset Name</th>
              <th>User</th>
              <th>Purchase</th>
              <th>Warranty</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Dell Laptop</td>
                <td>Antony</td>
                <td>12 Sep</td>
                <td>12 Months</td>
                <td><span className="badge bg-success">Active</span></td>
                <td>✏️ 🗑</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Assets;